module.exports = __webpack_public_path__ + "./images/a516f29a924fed9d0adf56d4a19cc559.webp";